// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".btt-button-enter-active, .btt-button-leave-active{transition-property:height;transition-duration:200ms;transition-timing-function:cubic-bezier(0.4, 0, 0.2, 1)}.btt-button-enter, .btt-button-leave-to{height:0px}.btt-button-enter-to, .btt-button-leave{height:50px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
